export const FavoriteEventId = 'FavoriteEntityEventId';
export const folderTypeName = 'DecisionsFramework.ServiceLayer.Services.Folder.Folder';
export const accountTypeName = 'DecisionsFramework.ServiceLayer.Services.Accounts.Account';
